// extracted by mini-css-extract-plugin
module.exports = {"ad":"key-events-sidebar-module__ad__XKXoP"};